import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {PortalApiService} from './../../../../../shared/services/api/portal-api.service';
import {AppSettingsService} from './../../../../../shared/services/app-settings.service';
import { CVPurchasePayment } from './cv-purchase.model';
import { finalize } from 'rxjs/operators';

const apiEndpoints = {
  purchase: 'directorytransaction/purchase',
  receipt: 'directorytransaction/details'
};

@Injectable()
export class CVPurchaseService {
  constructor(private appSettings: AppSettingsService,
    private portalApiService: PortalApiService)
    {
    }

    purchaseCV(cvPaymentData: CVPurchasePayment): Observable<CVPurchasePayment> {
      return this.portalApiService.post(apiEndpoints.purchase, cvPaymentData)
        .pipe(finalize(() => null));
    }    

    getReceipt(email) {      
      return this.portalApiService.get(apiEndpoints.receipt,{email})
      .pipe(finalize(() => null));
    }
}